import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  offers: {
    marginTop: 8
  },
  offersLabel: {
    color: theme.palette.text.secondary,
    marginBottom: 4
  },
  offersLoading: {
    padding: '8px 0'
  },
  offerRow: {
    alignItems: 'flex-start',
    cursor: 'pointer',
    display: 'flex'
  },
  offerText: {
    display: 'flex',
    flexDirection: 'column',
    paddingTop: 9
  },
  card: {
    width: '100%',
    borderRadius: 8,
    background: theme.palette.grey[200],
    margin: '8px 0 16px',
    padding: theme.spacing(2)
  },
  title: {
    color: theme.palette.text.primary,
    fontWeight: 700,
    marginBottom: theme.spacing(0.5)
  },
  description: {
    color: theme.palette.grey[700],
    lineHeight: 1.6,
    marginBottom: theme.spacing(1.5)
  },
  // The field and its action on one row. They were siblings in a fragment, so the button
  // fell below a fullWidth field — the booking stepper's other forms put the action beside
  // or after its input, never under it.
  codeFieldRow: {
    alignItems: 'flex-start',
    display: 'flex',
    gap: 8
  },
  codeField: {
    background: theme.palette.background.paper,
    flex: 1
  },
  // Offset to the FIELD's height, not the text's — the label pushes the input down.
  applyButton: {
    marginTop: 22,
    whiteSpace: 'nowrap'
  },
  // The applied state REPLACES the field, so Remove is the way back.
  appliedRow: {
    background: theme.palette.background.paper,
    borderRadius: 8,
    padding: '8px 12px'
  },
  appliedHeader: {
    alignItems: 'flex-start',
    display: 'flex',
    gap: 12,
    justifyContent: 'space-between'
  },
  appliedText: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0
  },
  // The saving is the point of the section, so it is the one thing allowed to be loud.
  // Success colour, not an error red beside the word "applied".
  appliedAmount: {
    color: theme.palette.success.dark,
    fontWeight: 600
  },
  noSaving: {
    color: theme.palette.text.primary,
    fontWeight: 700
  },
  savingsRow: {
    alignItems: 'baseline',
    display: 'flex',
    flexWrap: 'wrap',
    gap: 8,
    justifyContent: 'space-between',
    marginTop: 8
  },
  allocationList: {
    borderInlineStart: `2px solid ${theme.palette.grey[400]}`,
    marginBlockEnd: 12,
    marginBlockStart: 4,
    marginInlineEnd: 12,
    marginInlineStart: 8,
    paddingBlock: 2,
    paddingInlineStart: 12
  },
  allocationRow: {
    alignItems: 'baseline',
    display: 'flex',
    flexWrap: 'wrap',
    gap: 8,
    justifyContent: 'space-between',
    minHeight: 20
  },
  totalSavings: {
    borderTop: `1px solid ${theme.palette.grey[300]}`,
    display: 'flex',
    flexWrap: 'wrap',
    fontWeight: 700,
    gap: 8,
    justifyContent: 'space-between',
    marginTop: 8,
    paddingTop: 8
  },
  // A discount is a number; it was a fragment of the offer's label. Pulled out so offers
  // compare down a column instead of being read one sentence at a time.
  offerDiscount: {
    color: theme.palette.success.dark,
    fontWeight: 700,
    marginLeft: 8
  },
  input: {
    background: theme.palette.background.paper
  },
  // The refusal, on its own line and announced.
  //
  // It used to ride as the input's helper text, which reaches assistive tech only through
  // aria-describedby — read when focus ENTERS the field, and the guest's focus is on the
  // Apply button they just pressed. Moved out so it can carry role="alert" and be heard when
  // it changes.
  //
  // error.dark, NOT warning.dark. Measured against this card's own grey[200] (#F4F6F8):
  // warning.dark #A47B00 gives 3.58:1 and error.dark #C90600 gives 5.52:1, against the 4.5:1
  // that body2 needs at 14px regular. The helper text this replaced used error.main #FF4842
  // at 3.10:1, so warning.dark was an improvement and still not a pass — the line that
  // distinguishes a code that applied from one that did not cannot be the one below the
  // threshold. A colour that fails contrast is the strongest possible form of fine print,
  // which is the thing this comment used to say it was avoiding.
  refusal: {
    color: theme.palette.error.dark,
    marginTop: 4
  },
  // Announced, not shown — for the in-flight state ONLY.
  //
  // Visually hidden is right here and was wrong for the refusal: the refusal has a visible
  // counterpart and a hidden copy would say the same sentence twice, while "checking" has
  // no text at all, only a spinner. There is nothing to duplicate.
  //
  // clip-path plus a 1px box rather than display/visibility:none — both of those remove the
  // node from the accessibility tree, which is the whole thing being asked for.
  announcement: {
    position: 'absolute',
    width: 1,
    height: 1,
    padding: 0,
    margin: -1,
    overflow: 'hidden',
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    whiteSpace: 'nowrap',
    border: 0
  }
}))

export default useStyles
